/*    
<summary>
  "AddConsumptionTaxForm" handles adding/updating consumption tax with validation and form reset on submit.
  Developer: Sahil Bharti
</summary>
<returns>JSX</returns>
*/
import { Form, Formik, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import Label from "../../../shared-components/label/label";
import LoaderButton from "../../../shared-components/button/loader-button";
import { integerRegex } from "../../../constants/constants";
import FormikFormInputForRegexCheck from "../../../shared-components/FormikFormHandlers/FormikFormInputForRegexCheck";
import { IConsumptionTaxState } from "../../../models/state/IMasterSettingsState";
import { ConsumptionTaxValidateSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { toHalfWidth } from "../../../helpers/validate-helper";
interface IProps {
  id: number;
  submitHandler: (data: IConsumptionTaxState) => void;
  loading: boolean;
  initialValues: IConsumptionTaxState;
  isUpdateMode: boolean;
  disableAction: boolean;
}

const AddConsumptionTaxForm = (props: IProps) => {
  return (
    <Formik
      initialValues={props.initialValues}
      enableReinitialize
      validationSchema={ConsumptionTaxValidateSchema}
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        props.submitHandler({
          ...values,
          TaxValue: toHalfWidth(values.TaxValue),
        });
        resetForm();
      }}
    >
      {() => (
        <Form className="setting-form" noValidate>
          <Row className="position-relative">
            <Col xs={12} md={12}>
              <Label className="form-label" required={true} label="tax" />
              <Field
                className="form-control"
                aria-label="Default select example"
                name="TaxValue"
                placeholder="enter_tax_value"
                regex={integerRegex}
                as={FormikFormInputForRegexCheck}
              />
            </Col>

            {/* Save Button */}
            <Col xs={12} md={12}>
              <LoaderButton
                type="submit"
                className="mt-3"
                isLoading={props.loading}
                disabled={props.disableAction}
                text={props.isUpdateMode ? "button_update" : "button_save"}
              />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default AddConsumptionTaxForm;
